import { WSQueryConfig } from "@ws-react-query";
import { useWSQuery } from "../../helpers";
import { QUERY_EMPLOYEE_TAX_FORMS_CHECKLIST } from "../keys";
import { employeeTaxFormsService } from "../../../services/employeeTaxForms";
import { WSServiceError } from "../../../utils/serviceHelper";
import { GetChecklistResponse } from "../../../services/employeeTaxForms/getChecklist";

export const useQueryEmployeeTaxFormsChecklist = (
  contextId: string,
  queryConfig?: WSQueryConfig<GetChecklistResponse, WSServiceError>
) =>
  useWSQuery<GetChecklistResponse, WSServiceError>(
    [QUERY_EMPLOYEE_TAX_FORMS_CHECKLIST, contextId],
    () => employeeTaxFormsService.getChecklist(contextId),
    {
      enabled: !!contextId,
      // Checklist status can change out-of-band (e.g. a correction issued via
      // the migration CLI); the app-wide staleTime:Infinity would otherwise
      // pin "Completed" for the whole session. Re-read on every mount.
      refetchOnMount: "always",
      staleTime: 0,
      ...queryConfig
    }
  );
